import type { ScrollMapPoint } from '@gem-sdk/heatmap-react';

export const MOCK_HEATMAP_SCROLL_DEPTH: ScrollMapPoint[] = [
  {
    scrollReachY: 1,
    cumulativeSum: 6730,
    percUsers: 100,
  },
  {
    scrollReachY: 2,
    cumulativeSum: 6729,
    percUsers: 99.98514115898959,
  },
  {
    scrollReachY: 3,
    cumulativeSum: 6726,
    percUsers: 99.9405646359584,
  },
  {
    scrollReachY: 4,
    cumulativeSum: 6722,
    percUsers: 99.88112927191679,
  },
  {
    scrollReachY: 5,
    cumulativeSum: 6719,
    percUsers: 99.8365527488856,
  },
  {
    scrollReachY: 6,
    cumulativeSum: 6708,
    percUsers: 99.67310549777118,
  },
  {
    scrollReachY: 7,
    cumulativeSum: 6676,
    percUsers: 99.19762258543834,
  },
  {
    scrollReachY: 8,
    cumulativeSum: 6364,
    percUsers: 94.56166419019316,
  },
  {
    scrollReachY: 9,
    cumulativeSum: 5945,
    percUsers: 88.33580980683506,
  },
  {
    scrollReachY: 10,
    cumulativeSum: 4894,
    percUsers: 72.71916790490341,
  },
  {
    scrollReachY: 11,
    cumulativeSum: 4087,
    percUsers: 60.728083209509656,
  },
  {
    scrollReachY: 12,
    cumulativeSum: 3154,
    percUsers: 46.864784546805346,
  },
  {
    scrollReachY: 13,
    cumulativeSum: 2040,
    percUsers: 30.312035661218424,
  },
  {
    scrollReachY: 14,
    cumulativeSum: 1729,
    percUsers: 25.690936106983653,
  },
  {
    scrollReachY: 15,
    cumulativeSum: 1566,
    percUsers: 23.26894502228826,
  },
  {
    scrollReachY: 16,
    cumulativeSum: 1435,
    percUsers: 21.322436849925705,
  },
  {
    scrollReachY: 17,
    cumulativeSum: 1171,
    percUsers: 17.39970282317979,
  },
  {
    scrollReachY: 18,
    cumulativeSum: 983,
    percUsers: 14.60624071322437,
  },
  {
    scrollReachY: 19,
    cumulativeSum: 912,
    percUsers: 13.551263001485884,
  },
  {
    scrollReachY: 20,
    cumulativeSum: 869,
    percUsers: 12.912332838038635,
  },
  {
    scrollReachY: 21,
    cumulativeSum: 819,
    percUsers: 12.169390787518573,
  },
  {
    scrollReachY: 22,
    cumulativeSum: 788,
    percUsers: 11.708766716196136,
  },
  {
    scrollReachY: 23,
    cumulativeSum: 758,
    percUsers: 11.263001485884102,
  },
  {
    scrollReachY: 24,
    cumulativeSum: 738,
    percUsers: 10.965824665676077,
  },
  {
    scrollReachY: 25,
    cumulativeSum: 718,
    percUsers: 10.668647845468053,
  },
  {
    scrollReachY: 26,
    cumulativeSum: 688,
    percUsers: 10.222882615156017,
  },
  {
    scrollReachY: 27,
    cumulativeSum: 659,
    percUsers: 9.791976225854384,
  },
  {
    scrollReachY: 28,
    cumulativeSum: 637,
    percUsers: 9.465081723625557,
  },
  {
    scrollReachY: 29,
    cumulativeSum: 612,
    percUsers: 9.093610698365527,
  },
  {
    scrollReachY: 30,
    cumulativeSum: 593,
    percUsers: 8.811292719167906,
  },
  {
    scrollReachY: 31,
    cumulativeSum: 579,
    percUsers: 8.603268945022288,
  },
  {
    scrollReachY: 32,
    cumulativeSum: 566,
    percUsers: 8.410104011887073,
  },
  {
    scrollReachY: 33,
    cumulativeSum: 552,
    percUsers: 8.202080237741455,
  },
  {
    scrollReachY: 34,
    cumulativeSum: 544,
    percUsers: 8.083209509658246,
  },
  {
    scrollReachY: 35,
    cumulativeSum: 531,
    percUsers: 7.890044576523031,
  },
  {
    scrollReachY: 36,
    cumulativeSum: 511,
    percUsers: 7.592867756315007,
  },
  {
    scrollReachY: 37,
    cumulativeSum: 502,
    percUsers: 7.459138187221397,
  },
  {
    scrollReachY: 38,
    cumulativeSum: 488,
    percUsers: 7.251114413075781,
  },
  {
    scrollReachY: 39,
    cumulativeSum: 480,
    percUsers: 7.13224368499257,
  },
  {
    scrollReachY: 40,
    cumulativeSum: 472,
    percUsers: 7.013372956909361,
  },
  {
    scrollReachY: 41,
    cumulativeSum: 456,
    percUsers: 6.775631500742942,
  },
  {
    scrollReachY: 42,
    cumulativeSum: 446,
    percUsers: 6.627043090638931,
  },
  {
    scrollReachY: 43,
    cumulativeSum: 435,
    percUsers: 6.463595839524518,
  },
  {
    scrollReachY: 44,
    cumulativeSum: 427,
    percUsers: 6.344725111441307,
  },
  {
    scrollReachY: 45,
    cumulativeSum: 418,
    percUsers: 6.210995542347697,
  },
  {
    scrollReachY: 46,
    cumulativeSum: 413,
    percUsers: 6.1367013372956905,
  },
  {
    scrollReachY: 47,
    cumulativeSum: 406,
    percUsers: 6.0326894502228825,
  },
  {
    scrollReachY: 48,
    cumulativeSum: 403,
    percUsers: 5.988112927191679,
  },
  {
    scrollReachY: 49,
    cumulativeSum: 397,
    percUsers: 5.898959881129271,
  },
  {
    scrollReachY: 50,
    cumulativeSum: 386,
    percUsers: 5.735512630014859,
  },
  {
    scrollReachY: 51,
    cumulativeSum: 377,
    percUsers: 5.601783060921249,
  },
  {
    scrollReachY: 52,
    cumulativeSum: 365,
    percUsers: 5.423476968796434,
  },
  {
    scrollReachY: 53,
    cumulativeSum: 352,
    percUsers: 5.2303120356612185,
  },
  {
    scrollReachY: 54,
    cumulativeSum: 335,
    percUsers: 4.977711738484398,
  },
  {
    scrollReachY: 55,
    cumulativeSum: 328,
    percUsers: 4.87369985141159,
  },
  {
    scrollReachY: 56,
    cumulativeSum: 323,
    percUsers: 4.799405646359585,
  },
  {
    scrollReachY: 57,
    cumulativeSum: 316,
    percUsers: 4.695393759286776,
  },
  {
    scrollReachY: 58,
    cumulativeSum: 308,
    percUsers: 4.576523031203566,
  },
  {
    scrollReachY: 59,
    cumulativeSum: 303,
    percUsers: 4.50222882615156,
  },
  {
    scrollReachY: 60,
    cumulativeSum: 299,
    percUsers: 4.442793462109956,
  },
  {
    scrollReachY: 61,
    cumulativeSum: 290,
    percUsers: 4.3090638930163445,
  },
  {
    scrollReachY: 62,
    cumulativeSum: 286,
    percUsers: 4.24962852897474,
  },
  {
    scrollReachY: 63,
    cumulativeSum: 280,
    percUsers: 4.160475482912332,
  },
  {
    scrollReachY: 64,
    cumulativeSum: 271,
    percUsers: 4.026745913818722,
  },
  {
    scrollReachY: 65,
    cumulativeSum: 260,
    percUsers: 3.863298662704309,
  },
  {
    scrollReachY: 66,
    cumulativeSum: 253,
    percUsers: 3.7592867756315007,
  },
  {
    scrollReachY: 67,
    cumulativeSum: 246,
    percUsers: 3.6552748885586928,
  },
  {
    scrollReachY: 68,
    cumulativeSum: 237,
    percUsers: 3.5215453194650816,
  },
  {
    scrollReachY: 69,
    cumulativeSum: 229,
    percUsers: 3.402674591381872,
  },
  {
    scrollReachY: 70,
    cumulativeSum: 226,
    percUsers: 3.3580980683506687,
  },
  {
    scrollReachY: 71,
    cumulativeSum: 223,
    percUsers: 3.3135215453194653,
  },
  {
    scrollReachY: 72,
    cumulativeSum: 217,
    percUsers: 3.2243684992570585,
  },
  {
    scrollReachY: 73,
    cumulativeSum: 214,
    percUsers: 3.179791976225854,
  },
  {
    scrollReachY: 74,
    cumulativeSum: 209,
    percUsers: 3.1054977711738485,
  },
  {
    scrollReachY: 75,
    cumulativeSum: 205,
    percUsers: 3.0460624071322435,
  },
  {
    scrollReachY: 76,
    cumulativeSum: 204,
    percUsers: 3.0312035661218424,
  },
  {
    scrollReachY: 77,
    cumulativeSum: 196,
    percUsers: 2.912332838038633,
  },
  {
    scrollReachY: 78,
    cumulativeSum: 189,
    percUsers: 2.808320950965825,
  },
  {
    scrollReachY: 79,
    cumulativeSum: 186,
    percUsers: 2.763744427934621,
  },
  {
    scrollReachY: 80,
    cumulativeSum: 184,
    percUsers: 2.734026745913819,
  },
  {
    scrollReachY: 81,
    cumulativeSum: 182,
    percUsers: 2.7043090638930165,
  },
  {
    scrollReachY: 82,
    cumulativeSum: 180,
    percUsers: 2.674591381872214,
  },
  {
    scrollReachY: 83,
    cumulativeSum: 176,
    percUsers: 2.6151560178306092,
  },
  {
    scrollReachY: 84,
    cumulativeSum: 173,
    percUsers: 2.5705794947994054,
  },
  {
    scrollReachY: 85,
    cumulativeSum: 172,
    percUsers: 2.5557206537890043,
  },
  {
    scrollReachY: 86,
    cumulativeSum: 171,
    percUsers: 2.540861812778603,
  },
  {
    scrollReachY: 87,
    cumulativeSum: 169,
    percUsers: 2.511144130757801,
  },
  {
    scrollReachY: 88,
    cumulativeSum: 164,
    percUsers: 2.436849925705795,
  },
  {
    scrollReachY: 89,
    cumulativeSum: 159,
    percUsers: 2.362555720653789,
  },
  {
    scrollReachY: 90,
    cumulativeSum: 155,
    percUsers: 2.3031203566121845,
  },
  {
    scrollReachY: 91,
    cumulativeSum: 152,
    percUsers: 2.2585438335809807,
  },
  {
    scrollReachY: 92,
    cumulativeSum: 151,
    percUsers: 2.2436849925705795,
  },
  {
    scrollReachY: 93,
    cumulativeSum: 148,
    percUsers: 2.199108469539376,
  },
  {
    scrollReachY: 94,
    cumulativeSum: 147,
    percUsers: 2.1842496285289745,
  },
  {
    scrollReachY: 95,
    cumulativeSum: 144,
    percUsers: 2.139673105497771,
  },
  {
    scrollReachY: 96,
    cumulativeSum: 141,
    percUsers: 2.0950965824665673,
  },
  {
    scrollReachY: 97,
    cumulativeSum: 135,
    percUsers: 2.0059435364041605,
  },
  {
    scrollReachY: 98,
    cumulativeSum: 123,
    percUsers: 1.8276374442793464,
  },
  {
    scrollReachY: 99,
    cumulativeSum: 112,
    percUsers: 1.6641901931649332,
  },
  {
    scrollReachY: 100,
    cumulativeSum: 94,
    percUsers: 1.3967310549777119,
  },
];
